<script>
/**
 * ****************************************************************************
 * @description     :   Button component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import _ from 'lodash-uuid';
/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of button component
 */
var FcButton = {
    template: template,
    props: {
        id: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        buttonClass: {
            type: String,
            default: ''
        },
        iconClass: {
            type: String,
            default: ''
        },
        labelClass: {
            type: String,
            default: ''
        },
        isDisabled: Boolean,
        isCircle: {
            type: Boolean,
            default: false
        },
        isOutline: {
            type: Boolean,
            default: false
        },
        type: String,
        icon: String,
        isShowTooltip: {
            type: Boolean,
            default: false
        },
        tooltipPosition: {
            type: String,
            default: ''
        },
        tooltipTitle: {
            type: String,
            default: ''
        },
        onClick: Function
    },
    computed: {
        btnId() {
            if (!this.id) {
                return _.uuid();
            }
            return this.id;
        },
        disabled() {
            return this.isDisabled;
        },
        /**
         * get class for button component
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        getClass() {
            let _class = this.buttonClass + ' custom-button btn';
            if (!this.isOutline) {
                if (this.type == 'danger') {
                    _class += ' btn-danger';
                } else if (this.type == 'secondary') {
                    _class += ' btn-secondary';
                } else if (this.type == 'success') {
                    _class += ' btn-success';
                } else if (this.type == 'info') {
                    _class += ' btn-info';
                } else if (this.type == 'gray') {
                    _class += ' btn-gray';
                } else {
                    _class += ' btn-primary';
                }
            } else {
                if (this.type == 'danger') {
                    _class += ' btn-outline-danger';
                } else if (this.type == 'secondary') {
                    _class += ' btn-outline-secondary';
                } else if (this.type == 'success') {
                    _class += ' btn-outline-success';
                } else if (this.type == 'info') {
                    _class += ' btn-outline-info';
                } else if (this.type == 'gray') {
                    _class += ' btn-outline-gray';
                } else {
                    _class += ' btn-outline-primary';
                }
            }
            if (this.isCircle) {
                _class += ' rounded-circle p-0';
            }
            return _class;
        }
    },
    methods: {
        clickButton(e) {
            if (this.onClick) {
                this.onClick(e);
            }
        }
    }
};
export default FcButton;
</script>
